import { Tag, TTagVariant } from '@ui';
import React from 'react';
import type { TPairingStatus } from 'types/provider.types';

const COLOR_MAP: Record<TPairingStatus, TTagVariant> = {
  pending: 'info',
  approved: 'success',
  rejected: 'danger',
  invited: 'warning',
  changed: 'info',
};

const TRANS_MAP: Record<TPairingStatus, string> = {
  pending: 'Čaká na schválenie',
  changed: 'Zmena',
  approved: 'Schválený',
  rejected: 'Odmietnutý',
  invited: 'Pozvaný',
};

interface ProviderStatusProps {
  status: TPairingStatus;
}

const PairingStatus: React.FunctionComponent<ProviderStatusProps> = ({ status }) => {
  return <Tag variant={COLOR_MAP[status]}>{TRANS_MAP[status]}</Tag>;
};

export default PairingStatus;
